<nav class="breadcrumb">
	<a class="breadcrumb-item" [routerLink]="['../../../']">My {{brand.fleetPlural}}</a>
	<span class="breadcrumb-item active">{{fleet?.fleet_name}}</span>
</nav>
<div *ngIf="fleet">
	<div class="item-panel corner">
		<div class="heading">{{brand.fleetSingular}} Overview</div>
		<div class="content">
			<div class="row border-between">
				<div class="col-sm-4 col-md-3">
					<div><b>{{brand.fleetSingular}}:</b> {{fleet.fleet_name}}</div>
					<div><b>Number of {{brand.assetPlural}}:</b> {{fleet.assets.length}}</div>
				</div>
				<div class="col-sm-4 col-md-2">
					<div><b>Remaining Useful Life:</b></div>
					<div *ngIf="fleet.rulmin">{{fleet.rulmin | number : "1.2-2"}} hrs</div>
					<div *ngIf="!fleet.rulmin">No problems detected</div>
				</div>
				<div class="col-sm-4 col-md-3">
					<div class="overall-indicator">
						<div>Overall {{brand.fleetSingular}} Overview</div>
						<app-health-indicator [hi]="fleet.totalhimax"></app-health-indicator>
					</div>
				</div>
				<div class="col-md-4 d-none d-md-block">
					<div><b>Sort:</b></div>
					<select class="form-control m-t-3" [ngModel]="sortType" (ngModelChange)="sortChange($event)">
						<option value="tail">{{brand.assetName}}</option>
						<option value="type">{{brand.assetSingular}} Type</option>
						<option value="health">Health Overview</option>
					</select>
				</div>
			</div>
		</div>
	</div>
	<app-asset-summary [routerLink]="['asset', asset.asset_id]" [asset]="asset" *ngFor="let asset of sortedAssets" class="clickable"></app-asset-summary>
</div>